import r from"../strings/ltrim.mjs";var t=function(t,n){return 0===t.indexOf("/")?"".concat(n).concat(r(t,["/"])):t};export{t as toShopifyURL};
//# sourceMappingURL=toShopifyURL.mjs.map
